export const consultantParentColumns = [
  { id: 'expand', label: '', width: '5%' },
  { id: 'date', label: 'Date', width: '25%' },
  { id: 'totalHoursRT', label: 'Regular Time', width: '35%' },
  { id: 'totalHoursOT', label: 'Overtime', width: '35%' },
];

export const consultantChildColumns = [
  { id: 'spacer', label: '', width: '5%' },
  { id: 'regularTime', label: 'Regular', width: '15%' },
  { id: 'overTime', label: 'Overtime', width: '15%' },
  { id: 'caseTitle', label: 'Case', width: '35%' },
  { id: 'customerName', label: 'Customer', width: '30%' },
];
